module.exports = __webpack_public_path__ + "img/text_3.dd34b992.svg";